import { onBeforeUnmount } from 'vue'
import bus from '@/event-bus/EventBus'
import { GridLayout } from '@/types/dashboard'
import { GridStack } from 'gridstack'

export const GRID_COLUMNS = 64

export function getGrid (widgetGroupID: number) {
    if (!window.grids) {
        return
    }

    return window.grids[widgetGroupID]
}

export function setGrid (widgetGroupID: number, grid: GridStack) {
    if (!window.grids) {
        window.grids = {}
    }

    window.grids[widgetGroupID] = grid
}

export function makeGridStackWidget (widgetGroupID: number, id: number) {
    const currentGrid = getGrid(widgetGroupID)

    if (!currentGrid) {
        return
    }

    const el = document.getElementById(id.toString())

    if (!el || el.classList.contains('initialized-item')) {
        return
    }

    currentGrid.makeWidget(`#${id}`)
}

export function removeGridStackWidget (widgetGroupID: number, id: number) {
    const currentGrid = getGrid(widgetGroupID)

    if (!currentGrid) {
        return
    }

    currentGrid.removeWidget(`#${id}`)
}

export function updateGridStackWidgetLayout (widgetGroupID: number, id: number, layout: GridLayout | undefined) {
    const currentGrid = getGrid(widgetGroupID)

    if (!currentGrid || !layout) {
        return
    }

    currentGrid.move(`#${id}`, layout.x, layout.y)
    currentGrid.resize(`#${id}`, layout.width, layout.height)
}

export default function (widgetGroupID: number) {
    function getCurrentGrid () {
        return getGrid(widgetGroupID)
    }

    function onGSResizeStop (_: unknown, element: HTMLElement) {
        const widgetID = element.getAttribute('data-gs-id')
        bus.emit('widget-resized', widgetID)
    }

    function initWindowGrid (el: HTMLElement, editable: boolean) {
        const grid = window.GridStack.init(
            {
                acceptWidgets: true,
                column: GRID_COLUMNS
            },
            el
        )

        if (!grid) {
            return
        }

        grid.movable('.grid-stack-item', editable)
        grid.resizable('.grid-stack-item', editable)
        setGrid(widgetGroupID, grid)

        grid?.on(
            'gsresizestop',
            onGSResizeStop
        )
    }

    function destroyWindowGrid () {
        const grid = window.grids[widgetGroupID]

        if (grid) {
            grid.destroy()
            delete window.grids[widgetGroupID]
        }
    }

    function makeWidget (id: number) {
        makeGridStackWidget(widgetGroupID, id)
    }

    function removeWidget (id: number) {
        removeGridStackWidget(widgetGroupID, id)
    }

    onBeforeUnmount(() => {
        destroyWindowGrid()
    })

    return {
        initWindowGrid,
        getCurrentGrid,
        makeWidget,
        removeWidget
    }
}
